import { render, staticRenderFns } from "./MillageConfirm.vue?vue&type=template&id=10174dff&"
import script from "./MillageConfirm.vue?vue&type=script&lang=js&"
export * from "./MillageConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports